import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ChatMessage } from "@/components/ChatMessage";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { LogoLockup } from "@/components/Logo";

export default function SharedChat() {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get(`/share/${shareId}`)
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, [shareId]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col">
      <header className="border-b border-white/10 nig-glass sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="shared-logo">
            <LogoLockup />
          </Link>
          <Button
            data-testid="shared-try-cta"
            onClick={() => navigate("/login")}
            className="h-9 px-4 bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg text-sm transition-colors"
          >
            Try NIGAMAI free
          </Button>
        </div>
      </header>

      <div className="flex-1">
        {error ? (
          <div className="max-w-md mx-auto text-center py-32 px-6">
            <div className="w-14 h-14 rounded-2xl bg-[#141415] border border-white/10 flex items-center justify-center mx-auto mb-6">
              <Sparkles className="w-6 h-6 text-zinc-500" />
            </div>
            <h1 className="font-heading font-bold text-2xl tracking-tighter">This chat is unavailable</h1>
            <p className="text-zinc-500 mt-2">The link may have been removed or made private.</p>
            <Button onClick={() => navigate("/")} className="mt-6 bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg transition-colors">
              Go home
            </Button>
          </div>
        ) : !data ? (
          <div className="flex items-center justify-center py-32">
            <Loader2 className="w-6 h-6 text-[#00FF66] animate-spin" />
          </div>
        ) : (
          <div className="max-w-4xl mx-auto px-4 py-10">
            <div className="mb-8 pb-6 border-b border-white/10">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-white/10 bg-[#141415] text-xs text-zinc-400 mb-3">
                <Sparkles className="w-3.5 h-3.5 text-[#00FF66]" /> Shared build
              </span>
              <h1 className="font-heading font-extrabold text-3xl tracking-tighter">{data.title}</h1>
              <p className="text-zinc-500 mt-1 text-sm">Built by {data.author} on NIGAMAI</p>
            </div>
            <div className="space-y-8">
              {data.messages.map((m, i) => (
                <ChatMessage key={i} role={m.role} content={m.content} images={m.images} />
              ))}
            </div>
            <div className="mt-14 text-center rounded-2xl border border-[#00FF66]/20 bg-[#101a12] p-8">
              <h2 className="font-heading font-bold text-2xl tracking-tighter">Want to build like this?</h2>
              <p className="text-zinc-400 mt-2">Get 50 free credits and start creating in seconds.</p>
              <Button onClick={() => navigate("/login")} className="mt-5 bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg px-6 transition-colors">
                Start building free
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
